import { Route } from 'react-router-dom'
import PimEmployeeDetail from '../pages/employees/pim-detail'
import JopPosition from '../components/employees/pim-detail/employee-info/jop-position'
import EmployeeInfo from '../components/employees/pim-detail/employee-info'
import {
  INFO_CERTIFICATE,
  INFO_CRIMINAL,
  INFO_DOCUMENT,
  INFO_EDUC,
  INFO_EMER,
  INFO_HIST,
  INFO_PERSONAL,
  INFO_RESIGNS,
  INFO_WORK,
  PIM_EMP_INFO,
  PIM_EMP_PERSONAL_PROFILE,
  PIM_EMP_PROPERTY,
  PIM_EMP_PROPERTY_ASS,
  PIM_EMP_WELFARE,
  PIM_EMP_WELFARE_BEM,
  PIM_EMP_WELFARE_CAR,
  PIM_EMP_WELFARE_CAR_PARK,
  PIM_EMP_WELFARE_EJIP,
  PIM_EMP_WELFARE_FIT_FIRM,
  PIM_EMP_WELFARE_LEAVE,
  PIM_EMP_WELFARE_LOAN_HOME,
  PIM_EMP_WELFARE_PVD
} from './routes'
import PersonalProfile from '../components/employees/pim-detail/personal-profile'
import PropertyInfoASS from '../components/employees/pim-detail/property-info/assets'
import PropertyInfo from '../components/employees/pim-detail/property-info'
import EmpWelfareLeave from '../components/employees/pim-detail/welfare/leave'
import EmpWelfareFitFirm from '../components/employees/pim-detail/welfare/fit-firm'
import EmpWelfareCarPark from '../components/employees/pim-detail/welfare/car-park'
import EmpWelfareLoanHomePage from '../components/employees/pim-detail/welfare/loan-home'
import EmpWelfareCar from '../components/employees/pim-detail/welfare/car'
import EmpWelfareBEM from '../components/employees/pim-detail/welfare/bem'
import EmpWelfarePVD from '../components/employees/pim-detail/welfare/pvd'
import EmpWelfareEJIP from '../components/employees/pim-detail/welfare/e-jip'
import EmpWelfare from '../components/employees/pim-detail/welfare'
import InfoResignsEmployeePage from '../components/employees/pim-detail/employee-info/resigns-employee'
import Certificate from '../components/employees/pim-detail/employee-info/certificate'
import Document from '../components/employees/pim-detail/employee-info/document'
import CriminalRecord from '../components/employees/pim-detail/employee-info/criminal-record'
import WorkHistory from '../components/employees/pim-detail/employee-info/work-history'
import EducationHistory from '../components/employees/pim-detail/employee-info/education-history'
import EmergencyContact from '../components/employees/pim-detail/employee-info/emergency-contact'
import PersonalDetails from '../components/employees/pim-detail/employee-info/personal-details'
import HistoricalData from '../components/employees/pim-detail/employee-info/historical-data'

export const EmpPimRoutes = (
  <Route element={<PimEmployeeDetail />}>
    <Route element={<EmployeeInfo />}>
      <Route path={`${PIM_EMP_INFO}/:id`} element={<JopPosition />} />
      <Route path={`${INFO_HIST}/:id`} element={<HistoricalData />} />
      <Route path={`${INFO_PERSONAL}/:id`} element={<PersonalDetails />} />
      <Route path={`${INFO_EMER}/:id`} element={<EmergencyContact />} />
      <Route path={`${INFO_EDUC}/:id`} element={<EducationHistory />} />
      <Route path={`${INFO_WORK}/:id`} element={<WorkHistory />} />
      <Route path={`${INFO_CRIMINAL}/:id`} element={<CriminalRecord />} />
      <Route path={`${INFO_DOCUMENT}/:id`} element={<Document />} />
      <Route path={`${INFO_CERTIFICATE}/:id`} element={<Certificate />} />
      <Route
        path={`${INFO_RESIGNS}/:id`}
        element={<InfoResignsEmployeePage />}
      />
    </Route>

    <Route path={`${PIM_EMP_WELFARE}/:id`} element={<EmpWelfare />} />
    <Route path={`${PIM_EMP_WELFARE_EJIP}/:id`} element={<EmpWelfareEJIP />} />
    <Route path={`${PIM_EMP_WELFARE_PVD}/:id`} element={<EmpWelfarePVD />} />
    <Route path={`${PIM_EMP_WELFARE_BEM}/:id`} element={<EmpWelfareBEM />} />
    <Route path={`${PIM_EMP_WELFARE_CAR}/:id`} element={<EmpWelfareCar />} />
    <Route
      path={`${PIM_EMP_WELFARE_LOAN_HOME}/:id`}
      element={<EmpWelfareLoanHomePage />}
    />
    <Route
      path={`${PIM_EMP_WELFARE_CAR_PARK}/:id`}
      element={<EmpWelfareCarPark />}
    />
    <Route
      path={`${PIM_EMP_WELFARE_FIT_FIRM}/:id`}
      element={<EmpWelfareFitFirm />}
    />
    <Route
      path={`${PIM_EMP_WELFARE_LEAVE}/:id`}
      element={<EmpWelfareLeave />}
    />

    <Route path={`${PIM_EMP_PROPERTY}/:id`} element={<PropertyInfo />} />
    <Route path={`${PIM_EMP_PROPERTY_ASS}/:id`} element={<PropertyInfoASS />} />
    <Route
      path={`${PIM_EMP_PERSONAL_PROFILE}/:id`}
      element={<PersonalProfile />}
    />
  </Route>
)
